'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('mail-recipient-edit', {
      url: '/mail/recipient/edit/:id',
      template: '<mail-recipient-edit></mail-recipient-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/messaging/mail/recipient/edit/mail-recipient-edit.routes.js